import { AxiosError } from "axios"

export const isAuthError = (error: unknown): boolean => {
  if (!(error instanceof AxiosError)) {
    return false
  }

  const status = error.response?.status ?? 0
  return status === 401 || status === 403
}
